var React = require('react');

function IconDailyActiveUser (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M48.89 420.49a27.11 27.11 0 0 1-43.55-32.3L130.46 219.5a27.11 27.11 0 0 1 47.07 6.41l60.78 158 141-262.16c10.75-20 39.86-18.71 48.79 2.17l135.38 316.16L668.12 20.55c6.23-24.95 40.44-28 51-4.59l83.41 184.9a27.11 27.11 0 1 1-49.42 22.29l-51.3-113.7-105.25 422c-6.28 25.21-41 28-51.22 4.11L400.4 196.98 258.08 461.55c-11 20.41-40.85 18.52-49.17-3.11l-64.27-167z"}));
}

IconDailyActiveUser.displayName = "IconDailyActiveUser";

IconDailyActiveUser.defaultProps = {"data-name":"图层 1","viewBox":"0 0 804.96 551.96"};

module.exports = IconDailyActiveUser;

IconDailyActiveUser.default = IconDailyActiveUser;
